<template>
  <div >
    <a-tabs defaultActiveKey="1" :style="{overflow:'visible'}">
      <a-tab-pane tab="全局标注" key="1" >
        <label-tree :labelType=1 />
      </a-tab-pane>
      <a-tab-pane tab="局部标注" key="2">
        <label-tree :labelType=2 />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import LabelTree from './modules/LabelTree'
export default {
  name: 'LabelTreesTab',
  components: {
    LabelTree
  },
}
</script>
